<template>
    <div class="loading-container">

        <LoadingSpinner v-if="progress <=100" />
        <ExclamationDiamondFill v-else class="loading-container-error" />

        <div class="loading-container-bars">
            <ProgressBarAuthenticated />
            <slot></slot>
        </div>

        <!--
        <h5>Authenticated
            <ProgressBar :percent="loggedIn ? 100 : 0" />    
        </h5>

         <h5 v-if="percentMe >= 0">My data
            <ProgressBar :percent="percentMe" />
        </h5>
        <h5 v-if="percentAppointments >= 0">Sessions
            <ProgressBar :percent="percentAppointments" />
        </h5>
        <h5 v-if="percentMeetings >= 0">Meetings
            <ProgressBar :percent="percentMeetings" />
        </h5>
        -->

        <div v-if="percentRoot > 100" 
            class="alert">
            <b>Sorry!</b> Please reload this page.
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import ExclamationDiamondFill from "@/components/icons/ExclamationDiamondFill";
    // import ProgressBar from "@/components/ProgressBar";

    import LoadingSpinner from "./LoadingSpinner";
    import ProgressBarAuthenticated from "./ProgressBarAuthenticated";


    export default {
        name: "Loading",
        components: {
            ExclamationDiamondFill,
            LoadingSpinner,
            // ProgressBar,
            ProgressBarAuthenticated,
        },
        props: {
            progress: {
                type: Number, // 0 - 101 : Error if >100
                // required: true
                default: 0,
            }
        },
        computed: {
            percentRoot() {
                return this.$store.state.loading;
            },
            percentSlots() {
                return this.$store.state.slots.loading;
            },
            percentMe() {
                return this.$store.state.me.loading;
            },
            percentAppointments() {
                return this.$store.state.appointments.loading;
            },
            percentMeetings() {
                return this.$store.state.meetings.loading;
            },
            /*
            percentTracks() {
                return this.$store.state.tracks.loading;
            },
            percentMessages() {
                return this.$store.state.messages.loading;
            },
            percentMeetings() {
                return this.$store.state.meetings.loading;
            },
            percentAttendees() {
                return this.$store.state.attendees.loading;
            },
            percentOrganisations() {
                return this.$store.state.organisations.loading;
            },
            */
            ...mapGetters({
                loggedIn: 'loggedIn',
            }),
        },
    }
</script>

<style>
.loading-container {
    background-color: #f6f6f6;
    border-radius: 5px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 auto;
    padding: 10px;
    width: 300px;
}
.loading-container h3 {
    text-align: center;
}
.loading-container .progress {
    margin-bottom: 0;
}

.loading-container-error {
    color: #c43c35;
    height: 40px;
    width: 40px;
    margin: 10px auto;
}
</style>